const actions = {
  SET_STATE: 'apps/SET_STATE',
  UPDATE_ACTIVE_APP: 'apps/UPDATE_ACTIVE_APP',
  LIST: 'apps/LIST',
  ADD: 'apps/ADD',
  DELETE: 'apps/DELETE',
  EDIT: 'apps/EDIT',
  API_KEYS_LIST: 'apps/API_KEYS_LIST',
  USERS_LIST: 'apps/USERS_LIST',
  ADD_USER: 'apps/ADD_USER',
  GET_USER: 'apps/GET_USER',
  UPDATE_USER: 'apps/UPDATE_USER',
  DELETE_USER: 'apps/DELETE_USER',
  DEACTIVATE_USER: 'apps/DEACTIVATE_USER',
  ACTIVATE_USER: 'apps/ACTIVATE_USER',
  SEARCH_USER: 'apps/SEARCH_USER',
  SEARCH_INACTIVE_USER: 'apps/SEARCH_INACTIVE_USER',
  ENTER_USER_TEXT: 'apps/ENTER_USER_TEXT',
  ENTER_INACTIVE_USER_TEXT: 'apps/ENTER_INACTIVE_USER_TEXT',
  USER_AUTH_TOKENS_LIST: 'apps/USER_AUTH_TOKENS_LIST',
  DELETE_USER_AUTH_TOKEN: 'apps/DELETE_USER_AUTH_TOKEN',
  ADD_USER_AUTH_TOKEN: 'apps/ADD_USER_AUTH_TOKEN',
  ENTER_UAUTHTOKEN_TEXT: 'apps/ENTER_UAUTHTOKEN_TEXT',
  SEARCH_UAUTHTOKEN: 'apps/SEARCH_UAUTHTOKEN',
  ROLES_LIST: 'apps/ROLES_LIST',
  ADD_ROLE: 'apps/ADD_ROLE',
  GET_ROLE: 'apps/GET_ROLE',
  UPDATE_ROLE: 'apps/UPDATE_ROLE',
  DELETE_ROLE: 'apps/DELETE_ROLE',
  SEARCH_ROLE: 'apps/SEARCH_ROLE',
  ENTER_ROLE_TEXT: 'apps/ENTER_ROLE_TEXT',
  GROUPS_LIST: 'apps/GROUPS_LIST',
  BOTS_LIST: 'apps/BOTS_LIST',
  GET_BOT: 'apps/GET_BOT',
  ADD_BOT: 'apps/ADD_BOT',
  UPDATE_BOT: 'apps/UPDATE_BOT',
  DELETE_BOT: 'apps/DELETE_BOT',
  CHANGE_BOT_STATUS: 'apps/CHANGE_BOT_STATUS',
  TRIGGERS_LIST: 'apps/TRIGGERS_LIST',
  WEBHOOKS_LIST: 'apps/WEBHOOKS_LIST',
  GET_WEBHOOK: 'apps/GET_WEBHOOK',
  ADD_WEBHOOK: 'apps/ADD_WEBHOOK',
  UPDATE_WEBHOOK: 'apps/UPDATE_WEBHOOK',
  DELETE_WEBHOOK: 'apps/DELETE_WEBHOOK',
  CHANGE_WEBHOOK_STATUS: 'apps/CHANGE_WEBHOOK_STATUS',
  TRIGGERS_LIST_NEW: 'apps/TRIGGERS_LIST_NEW',
  WEBHOOKS_LIST_NEW: 'apps/WEBHOOKS_LIST_NEW',
  GET_WEBHOOK_NEW: 'apps/GET_WEBHOOK_NEW',
  ADD_WEBHOOK_NEW: 'apps/ADD_WEBHOOK_NEW',
  UPDATE_WEBHOOK_NEW: 'apps/UPDATE_WEBHOOK_NEW',
  DELETE_WEBHOOK_NEW: 'apps/DELETE_WEBHOOK_NEW',
  CHANGE_WEBHOOK_STATUS_NEW: 'apps/CHANGE_WEBHOOK_STATUS_NEW',
  EXTENSIONS_LIST: 'apps/EXTENSIONS_LIST',
  ADD_EXTENSION: 'apps/ADD_EXTENSION',
  REMOVE_EXTENSION: 'apps/REMOVE_EXTENSION',
  ENTER_EXTENSION_TEXT: 'apps/ENTER_EXTENSION_TEXT',
  CHANGE_EXTENSION_STATUS: 'apps/CHANGE_EXTENSION_STATUS',
  ENABLE_DISABLE_EXTENSION: 'apps/ENABLE_DISABLE_EXTENSION',
  ADD_GROUP: 'apps/ADD_GROUP',
  GET_GROUP: 'apps/GET_GROUP',
  UPDATE_GROUP: 'apps/UPDATE_GROUP',
  DELETE_GROUP: 'apps/DELETE_GROUP',
  SEARCH_GROUP: 'apps/SEARCH_GROUP',
  ENTER_GROUP_TEXT: 'apps/ENTER_GROUP_TEXT',
  ENTER_GROUP_MEMBER_TEXT: 'apps/ENTER_GROUP_MEMBER_TEXT',
  ENTER_BANNED_GROUP_MEMBER_TEXT: 'apps/ENTER_BANNED_GROUP_MEMBER_TEXT',
  SEARCH_GROUP_MEMBER: 'apps/SEARCH_GROUP_MEMBER',
  SEARCH_BANNED_GROUP_MEMBER: 'apps/SEARCH_BANNED_GROUP_MEMBER',
  GET_GROUP_MEMBERS: 'apps/GET_GROUP_MEMBERS',
  GET_BANNED_GROUP_MEMBERS: 'apps/GET_BANNED_GROUP_MEMBERS',

  // AI Agents actions
  AI_AGENTS_LIST: 'apps/AI_AGENTS_LIST',
  ADD_AI_AGENT: 'apps/ADD_AI_AGENT',
  DELETE_AI_AGENT: 'apps/DELETE_AI_AGENT',
  EDIT_AI_AGENT: 'apps/EDIT_AI_AGENT',
  GET_AI_AGENT_CREATE_FORM: 'apps/GET_AI_AGENT_CREATE_FORM',
  GET_AI_AGENT_EDIT_FORM: 'apps/GET_AI_AGENT_EDIT_FORM',
  GET_AI_AGENT_INTEGRATIONS: 'apps/GET_AI_AGENT_INTEGRATIONS',

  // AI Agents Builder actions
  AI_AGENTS_BUILDER_LIST: 'apps/AI_AGENTS_BUILDER_LIST',
  GET_AI_AGENT_BUILDER: 'apps/GET_AI_AGENT_BUILDER',
  ADD_AI_AGENT_BUILDER: 'apps/ADD_AI_AGENT_BUILDER',
  DELETE_AI_AGENT_BUILDER: 'apps/DELETE_AI_AGENT_BUILDER',
  EDIT_AI_AGENT_BUILDER: 'apps/EDIT_AI_AGENT_BUILDER',
  GET_AI_AGENT_BUILDER_CREATE_FORM: 'apps/GET_AI_AGENT_BUILDER_CREATE_FORM',
  GET_AI_AGENT_BUILDER_EDIT_FORM: 'apps/GET_AI_AGENT_BUILDER_EDIT_FORM',
  GET_AI_AGENT_BUILDER_INTEGRATIONS: 'apps/GET_AI_AGENT_BUILDER_INTEGRATIONS',

  // AI Tools actions
  AI_TOOLS_LIST: 'apps/AI_TOOLS_LIST',
  GET_AI_TOOL: 'apps/GET_AI_TOOL',
  GET_AI_TOOL_EDIT_FORM: 'apps/GET_AI_TOOL_EDIT_FORM',
  GET_AI_ACTION_EDIT_FORM: 'apps/GET_AI_ACTION_EDIT_FORM',
  GET_AI_TOOL_CREATE_FORM: 'apps/GET_AI_TOOL_CREATE_FORM',
  GET_AI_ACTION_CREATE_FORM: 'apps/GET_AI_ACTION_CREATE_FORM',
  ADD_AI_TOOL: 'apps/ADD_AI_TOOL',
  DELETE_AI_TOOL: 'apps/DELETE_AI_TOOL',
  EDIT_AI_TOOL: 'apps/EDIT_AI_TOOL',

  // AI Actions actions (separate from tools)
  AI_ACTIONS_LIST: 'apps/AI_ACTIONS_LIST',
  GET_AI_ACTION: 'apps/GET_AI_ACTION',
  ADD_AI_ACTION: 'apps/ADD_AI_ACTION',
  DELETE_AI_ACTION: 'apps/DELETE_AI_ACTION',
  EDIT_AI_ACTION: 'apps/EDIT_AI_ACTION',

  // AI Tools Builder actions
  AI_TOOLS_BUILDER_LIST: 'apps/AI_TOOLS_BUILDER_LIST',
  GET_AI_TOOL_BUILDER: 'apps/GET_AI_TOOL_BUILDER',
  GET_AI_TOOL_BUILDER_EDIT_FORM: 'apps/GET_AI_TOOL_BUILDER_EDIT_FORM',
  GET_AI_ACTION_BUILDER_EDIT_FORM: 'apps/GET_AI_ACTION_BUILDER_EDIT_FORM',
  GET_AI_TOOL_BUILDER_CREATE_FORM: 'apps/GET_AI_TOOL_BUILDER_CREATE_FORM',
  GET_AI_ACTION_BUILDER_CREATE_FORM: 'apps/GET_AI_ACTION_BUILDER_CREATE_FORM',
  ADD_AI_TOOL_BUILDER: 'apps/ADD_AI_TOOL_BUILDER',
  DELETE_AI_TOOL_BUILDER: 'apps/DELETE_AI_TOOL_BUILDER',
  EDIT_AI_TOOL_BUILDER: 'apps/EDIT_AI_TOOL_BUILDER',
  GET_AI_TOOL_ACTIONS: 'apps/GET_AI_TOOL_ACTIONS',
  CREATE_CUSTOM_API_TOOL: 'apps/CREATE_CUSTOM_API_TOOL',
  UPDATE_CUSTOM_API_TOOL: 'apps/UPDATE_CUSTOM_API_TOOL',
  DELETE_CUSTOM_API_TOOL: 'apps/DELETE_CUSTOM_API_TOOL',
  GET_CUSTOM_API_TOOLS_LIST: 'apps/GET_CUSTOM_API_TOOLS_LIST',
  ADD_API_TOOL_TO_AGENT: 'apps/ADD_API_TOOL_TO_AGENT',
  REMOVE_API_TOOL_FROM_AGENT: 'apps/REMOVE_API_TOOL_FROM_AGENT',
  // MCP Server actions
  CREATE_MCP_SERVER: 'apps/CREATE_MCP_SERVER',
  UPDATE_MCP_SERVER: 'apps/UPDATE_MCP_SERVER',
  DELETE_MCP_SERVER: 'apps/DELETE_MCP_SERVER',
  GET_MCP_SERVERS_LIST: 'apps/GET_MCP_SERVERS_LIST',
  GET_AVAILABLE_MODELS: 'apps/GET_AVAILABLE_MODELS',
  ADD_MCP_SERVER_TO_AGENT: 'apps/ADD_MCP_SERVER_TO_AGENT',
  REMOVE_MCP_SERVER_FROM_AGENT: 'apps/REMOVE_MCP_SERVER_FROM_AGENT',
  // Knowledge Base actions
  GET_KNOWLEDGE_BASE_LIST: 'apps/GET_KNOWLEDGE_BASE_LIST',
  GET_KNOWLEDGE_BASE_DETAILS: 'apps/GET_KNOWLEDGE_BASE_DETAILS',
  SYNC_KNOWLEDGE_BASE_ITEM: 'apps/SYNC_KNOWLEDGE_BASE_ITEM',
  DELETE_KNOWLEDGE_BASE_ITEM: 'apps/DELETE_KNOWLEDGE_BASE_ITEM',
  GET_KNOWLEDGE_BASE_INITIATE_FILE_UPLOAD: 'apps/GET_KNOWLEDGE_BASE_INITIATE_FILE_UPLOAD',
  KNOWLEDGE_BASE_CREATE_TEXT_ITEM: 'apps/KNOWLEDGE_BASE_CREATE_TEXT_ITEM',
  KNOWLEDGE_BASE_UPDATE_TEXT_ITEM: 'apps/KNOWLEDGE_BASE_UPDATE_TEXT_ITEM',
  KNOWLEDGE_BASE_CREATE_INDIVIDUAL_LINK: 'apps/KNOWLEDGE_BASE_CREATE_INDIVIDUAL_LINK',
  KNOWLEDGE_BASE_SCRAPE_WEBSITE: 'apps/KNOWLEDGE_BASE_SCRAPE_WEBSITE',
  KNOWLEDGE_BASE_PROCESS_DISCOVERED_URLS: 'apps/KNOWLEDGE_BASE_PROCESS_DISCOVERED_URLS',
  SYNC_DISCOVERED_URLS: 'apps/SYNC_DISCOVERED_URLS',
  KNOWLEDGE_BASE_GET_ITEM: 'apps/KNOWLEDGE_BASE_GET_ITEM',
  ADD_KNOWLEDGE_BASE_SOURCE_TO_AGENT: 'apps/ADD_KNOWLEDGE_BASE_SOURCE_TO_AGENT',
  REMOVE_KNOWLEDGE_BASE_SOURCE_FROM_AGENT: 'apps/REMOVE_KNOWLEDGE_BASE_SOURCE_FROM_AGENT',
  ADD_TOOL_TO_AGENT: 'apps/ADD_TOOL_TO_AGENT',
  REMOVE_TOOL_FROM_AGENT: 'apps/REMOVE_TOOL_FROM_AGENT',
  BAN_GROUP_MEMBER: 'apps/BAN_GROUP_MEMBER',
  UNBAN_GROUP_MEMBER: 'apps/UNBAN_GROUP_MEMBER',
  KICK_GROUP_MEMBER: 'apps/KICK_GROUP_MEMBER',
  ADD_APIKEY: 'apps/ADD_APIKEY',
  GET_APIKEY: 'apps/GET_APIKEY',
  DELETE_APIKEY: 'apps/DELETE_APIKEY',
  SEARCH_APIKEY: 'apps/SEARCH_APIKEY',
  ENTER_APIKEY_TEXT: 'apps/ENTER_APIKEY_TEXT',
  UPDATE_APIKEY: 'apps/UPDATE_APIKEY',
  GET: 'apps/GET',
  REDIRECT_DELETED_APPS: 'apps/REDIRECT_DELETED_APPS',
  KICK_USER_FROM_GROUP: 'apps/KICK_USER_FROM_GROUP',
  BAN_USER_FROM_GROUP: 'apps/BAN_USER_FROM_GROUP',
  ADD_USER_TO_GROUP: 'apps/ADD_USER_TO_GROUP',
  UPDATE_USER_FRIENDS: 'apps/UPDATE_USER_FRIENDS',
  SUBSCRIBE_TO_PLAN: 'apps/SUBSCRIBE_TO_PLAN',
  SUBSCRIBE_MODAL_CLOSE: 'apps/SUBSCRIBE_MODAL_CLOSE',
  SUBSCRIBE_MODAL_PROCEED: 'apps/SUBSCRIBE_MODAL_PROCEED',
  UNSUBSCRIBE_TO_PLAN: 'apps/UNSUBSCRIBE_TO_PLAN',
  UNSUBSCRIBE_TO_PLAN_ENDPOINT: 'apps/UNSUBSCRIBE_TO_PLAN_ENDPOINT',
  SAVE_APP_SETTINGS: 'apps/SAVE_APP_SETTINGS',
  GET_APP_SETTINGS: 'apps/GET_APP_SETTINGS',
  STRIPE_CHECKOUT_1: 'apps/STRIPE_CHECKOUT_1',
  STRIPE_CHECKOUT_2: 'apps/STRIPE_CHECKOUT_2',
  STRIPE_HANDLE_SERVER_RESPONSE: 'apps/STRIPE_HANDLE_SERVER_RESPONSE',
  STRIPE_HANDLE_ACTION: 'apps/STRIPE_HANDLE_ACTION',
  STRIPE_GOTO_CHECKOUT: 'apps/STRIPE_GOTO_CHECKOUT',
  REMOVE_ACTIVE_APP: 'apps/REMOVE_ACTIVE_APP',
  CALL_CHANGE_CUSTOM_PLAN_MANUAL_INTENT: 'apps/CALL_CHANGE_CUSTOM_PLAN_MANUAL_INTENT',
  CALL_SLACK_SUPPORT_MANUAL_INTENT: 'apps/CALL_SLACK_SUPPORT_MANUAL_INTENT',
  CHECK_IF_CUSTOM_PLAN: 'apps/CHECK_IF_CUSTOM_PLAN',
  RESUBSCRIBE: 'apps/RESUBSCRIBE',
  CANCEL_DOWNGRADE_EOT: 'apps/CANCEL_DOWNGRADE_EOT',
  USER_GROUPS_LIST: 'apps/USER_GROUPS_LIST',
  SEARCH_USER_GROUP: 'apps/SEARCH_USER_GROUP',
  ENTER_USER_GROUP_TEXT: 'apps/ENTER_USER_GROUP_TEXT',
  INACTIVE_USERS_LIST: 'apps/INACTIVE_USERS_LIST',
  CHANGE_MEMBER_SCOPE: 'apps/CHANGE_MEMBER_SCOPE',
  GET_MESSAGE_LOGS: 'apps/GET_MESSAGE_LOGS',
  GET_MOD_MESSAGE_LOGS: 'apps/GET_MOD_MESSAGE_LOGS',
  APPROVE_MOD_MESSAGE: 'apps/APPROVE_MOD_MESSAGE',
  REJECT_MOD_MESSAGE: 'apps/REJECT_MOD_MESSAGE',
  DELETE_MESSAGE_LOG: 'apps/DELETE_MESSAGE_LOG',
  CHAT_WIDGETS_LIST: 'apps/CHAT_WIDGETS_LIST',
  ADD_CHAT_WIDGET: 'apps/ADD_CHAT_WIDGET',
  GET_CHAT_WIDGET: 'apps/GET_CHAT_WIDGET',
  UPDATE_CHAT_WIDGET: 'apps/UPDATE_CHAT_WIDGET',
  ENTER_GROUP_TEXT_FOR_MODERATION: 'apps/ENTER_GROUP_TEXT_FOR_MODERATION',
  GROUPS_LIST_FOR_MODERATION: 'apps/GROUPS_LIST_FOR_MODERATION',
  SEARCH_GROUP_FOR_MODERATION: 'apps/SEARCH_GROUP_FOR_MODERATION',
  GET_GROUP_MESSAGE_LOGS: 'apps/GET_GROUP_MESSAGE_LOGS',
  DELETE_GROUP_MESSAGE_LOG: 'apps/DELETE_GROUP_MESSAGE_LOG',
  GET_GROUP_FOR_MODERATION: 'apps/GET_GROUP_FOR_MODERATION',
  IMPORT_USERS_REQUEST_MANUAL_INTENT: 'apps/IMPORT_USERS_REQUEST_MANUAL_INTENT',
  TEAM_COLLABORATOR_LIST: 'apps/TEAM_COLLABORATOR_LIST',
  TEAM_COLLABORATOR_INVITE: 'apps/TEAM_COLLABORATOR_INVITE',
  TEAM_COLLABORATOR_GET: 'apps/TEAM_COLLABORATOR_GET',
  TEAM_COLLABORATOR_UPDATE: 'apps/TEAM_COLLABORATOR_UPDATE',
  TEAM_COLLABORATOR_REMOVE: 'apps/TEAM_COLLABORATOR_REMOVE',
  TEAM_TRANSFER_OWNERSHIP: 'apps/TEAM_TRANSFER_OWNERSHIP',
  TEAM_COLLABORATOR_CHANGE_ROLE: 'apps/TEAM_COLLABORATOR_CHANGE_ROLE',
  TEAM_COLLABORATOR_LEAVE: 'apps/TEAM_COLLABORATOR_LEAVE',
  SEARCH_TEAM_COLLABORATOR: 'apps/SEARCH_TEAM_COLLABORATOR',
  ENTER_TEAM_COLLABORATOR_TEXT: 'apps/ENTER_TEAM_COLLABORATOR_TEXT',
  USER_FRIENDS_LIST: 'apps/USER_FRIENDS_LIST',
  SEARCH_USER_FRIEND: 'apps/SEARCH_USER_FRIEND',
  ENTER_USER_FRIEND_TEXT: 'apps/ENTER_USER_FRIEND_TEXT',
  ADD_FRIEND_TO_USER: 'apps/ADD_FRIEND_TO_USER',
  UNFRIEND_USER: 'apps/UNFRIEND_USER',
  GET_METRICS: 'apps/GET_METRICS',
  ENTER_APP_TEXT: 'apps/ENTER_APP_TEXT',
  SEARCH_APP: 'apps/SEARCH_APP',
  GET_MESSAGE_SEARCH_LOGS: 'apps/GET_MESSAGE_SEARCH_LOGS',
  ROLES_PERMISSIONS_LIST: 'apps/ROLES_PERMISSIONS_LIST',
  ADD_ROLE_RESTRICTION: 'apps/ADD_ROLE_RESTRICTION',
  GET_ROLE_RESTRICTIONS: 'apps/GET_ROLE_RESTRICTIONS',
  LIST_ROLE_RESTRICTIONS: 'apps/LIST_ROLE_RESTRICTIONS',
  DELETE_ROLE_RESTRICTION: 'apps/DELETE_ROLE_RESTRICTION',
  UPDATE_SUBSCRIBE_DOWNGRADE_EOT: 'apps/UPDATE_SUBSCRIBE_DOWNGRADE_EOT',
  SUBSCRIBE_CUSTOM_PLAN_REQUEST_MANUAL_INTENT: 'apps/SUBSCRIBE_CUSTOM_PLAN_REQUEST_MANUAL_INTENT',
  APP_MIGRATION_REQUEST_MANUAL_INTENT: 'apps/APP_MIGRATION_REQUEST_MANUAL_INTENT',
  RESTORE_DELETED_APP_REQUEST: 'apps/RESTORE_DELETED_APP_REQUEST',
  UPGRADE_PLAN_ON_FEATURE_RESTRICTION_MANUAL_INTENT:
    'apps/UPGRADE_PLAN_ON_FEATURE_RESTRICTION_MANUAL_INTENT',
  UPGRADE_PLAN_ON_EXTENSION_RESTRICTION_MANUAL_INTENT:
    'apps/UPGRADE_PLAN_ON_EXTENSION_RESTRICTION_MANUAL_INTENT',
  UPDATE_APP_STATE: 'apps/UPDATE_APP_STATE',
  GET_CALL_LOGS: 'apps/GET_CALL_LOGS',
  GET_MESSAGE_EXPORT_LOGS: 'apps/GET_MESSAGE_EXPORT_LOGS',
  GET_USAGE_AND_OVERAGES: 'apps/GET_USAGE_AND_OVERAGES',
  GET_INSIGHTS_DATA: 'apps/GET_INSIGHTS_DATA',
  DOWNLOAD_CALL_RECORDING: 'apps/DOWNLOAD_CALL_RECORDING',
  DOWNLOAD_CALL_RECORDING_LEGACY: 'apps/DOWNLOAD_CALL_RECORDING_LEGACY',
  GET_METRICS_BY_FILTER: 'apps/GET_METRICS_BY_FILTER',
  GET_MESSAGE_BY_ID: 'apps/GET_MESSAGE_BY_ID',
  GET_CALL_BY_ID: 'apps/GET_CALL_BY_ID',
  ADD_MEMBERS_TO_GROUP: 'apps/ADD_MEMBERS_TO_GROUP',
  EXPORT_USERS: 'apps/EXPORT_USERS',
  EXPORT_GROUPS: 'apps/EXPORT_GROUPS',
  INITIATE_NOTIFICATION: 'apps/INITIATE_NOTIFICATION',
  RESET_NOTIFICATION: 'apps/RESET_NOTIFICATION',
  APP_HIPAA_REGION_REQUEST_MANUAL_INTENT: 'apps/APP_HIPAA_REGION_REQUEST_MANUAL_INTENT',
  SHOW_INTENT_REQUEST: 'apps/SHOW_INTENT_REQUEST',
  HIDE_INTENT_REQUEST: 'apps/HIDE_INTENT_REQUEST',
  NON_PARTICIPANTS_LIST: 'apps/NON_PARTICIPANTS_LIST',
  SEARCH_NON_PARTICIPANT: 'apps/SEARCH_NON_PARTICIPANT',
  ENTER_NON_PARTICIPANT_TEXT: 'apps/ENTER_NON_PARTICIPANT_TEXT',
  SEARCH_USER_FRIEND_LIST: 'apps/SEARCH_USER_FRIEND_LIST',
  ENTER_USER_FRIEND_LIST_TEXT: 'apps/ENTER_USER_FRIEND_LIST_TEXT',
  SEARCH_GROUP_FRIEND_LIST: 'apps/SEARCH_GROUP_FRIEND_LIST',
  ENTER_USER_GROUP_LIST_TEXT: 'apps/ENTER_USER_GROUP_LIST_TEXT',
  NON_USER_FRIEND_LIST_MODAL: 'apps/NON_USER_FRIEND_LIST_MODAL',
  ENTER_NON_FRIEND_LIST_TEXT: 'apps/ENTER_NON_FRIEND_LIST_TEXT',
  SEARCH_NON_FRIEND_LIST_MODAL: 'apps/SEARCH_NON_FRIEND_LIST_MODAL',
  NON_USER_GROUP_LIST_MODAL: 'apps/NON_USER_GROUP_LIST_MODAL',
  ENTER_NON_GROUP_LIST_TEXT: 'apps/ENTER_NON_GROUP_LIST_TEXT',
  SEARCH_NON_GROUP_LIST_MODAL: 'apps/SEARCH_NON_GROUP_LIST_MODAL',
  SHOW_IMPORT_USER_REQUEST: 'apps/SHOW_IMPORT_USER_REQUEST',
  GET_CALL_SESSION_PARTICIPANT_DETAILS: 'apps/GET_CALL_SESSION_PARTICIPANT_DETAILS',
  GET_CALL_BY_ID_LEGACY: 'apps/GET_CALL_BY_ID_LEGACY',
  GET_CALL_LOGS_LEGACY: 'apps/GET_CALL_LOGS_LEGACY',
  GET_APP_MESSAGE_SETTINGS: 'apps/GET_APP_MESSAGE_SETTINGS',
  SAVE_APP_MESSAGE_SETTINGS: 'apps/SAVE_APP_MESSAGE_SETTINGS',
  ADD_APP_ON_ONBOARDING: 'apps/ADD_APP_ON_ONBOARDING',
  MODERATION_LIST_RULES: 'apps/MODERATION_LIST_RULES',
  MODERATION_GET_RULE: 'apps/MODERATION_GET_RULE',
  MODERATION_LIST_DROPPED_MESSAGES: 'apps/MODERATION_LIST_DROPPED_MESSAGES',
  MODERATION_LIST_FLAGGED_MESSAGES: 'apps/MODERATION_LIST_FLAGGED_MESSAGES',
  MODERATION_LIST_REVIEWED_MESSAGES: 'apps/MODERATION_LIST_REVIEWED_MESSAGES',
  MODERATION_ACCEPT_FLAGGED_MESSAGE: 'apps/MODERATION_ACCEPT_FLAGGED_MESSAGE',
  MODERATION_APPROVE_FLAGGED_MESSAGE: 'apps/MODERATION_APPROVE_FLAGGED_MESSAGE',
  MODERATION_BLOCK_FLAGGED_MESSAGE: 'apps/MODERATION_BLOCK_FLAGGED_MESSAGE',
  MODERATION_BAN_FLAGGED_MESSAGE_SENDER: 'apps/MODERATION_BAN_FLAGGED_MESSAGE_SENDER',
  MODERATION_LIST_KEYWORDS: 'apps/MODERATION_LIST_KEYWORDS',
  MODERATION_LIST_RULE_REVISIONS: 'apps/MODERATION_LIST_RULE_REVISIONS',
  MODERATION_GET_RULE_AND_RULE_REVISIONS: 'apps/MODERATION_GET_RULE_AND_RULE_REVISIONS',
  MODERATION_DELETE_RULE: 'apps/MODERATION_DELETE_RULE',
  CHANGE_MODERATION_RULE_STATUS: 'apps/CHANGE_MODERATION_RULE_STATUS',
  MODERATION_GET_KEYWORD: 'apps/MODERATION_GET_KEYWORD',
  MODERATION_DELETE_KEYWORD: 'apps/MODERATION_DELETE_KEYWORD',
  MODERATION_ADD_KEYWORD: 'apps/MODERATION_ADD_KEYWORD',
  MODERATION_UPDATE_KEYWORD: 'apps/MODERATION_UPDATE_KEYWORD',
  MODERATION_LIST_CONFIGURATION: 'apps/MODERATION_LIST_CONFIGURATION',
  MODERATION_ADD_RULE: 'apps/MODERATION_ADD_RULE',
  MODERATION_UPDATE_RULE: 'apps/MODERATION_UPDATE_RULE',
  MODERATION_UPDATE_BLOCKED_MESSAGE_STATUS: 'apps/MODERATION_UPDATE_BLOCKED_MESSAGE_STATUS',
  UPDATE_APP_SETTINGS: 'apps/UPDATE_APP_SETTINGS',
  GTM_TRIGGERED_MANUAL_INTENT: 'apps/GTM_TRIGGERED_MANUAL_INTENT',
  BUILDER_GET: 'apps/BUILDER_GET',
  BUILDER_UPDATE: 'apps/BUILDER_UPDATE',
  BUILDER_ADD: 'apps/BUILDER_ADD',
  BUILDER_LIST: 'apps/BUILDER_LIST',
  AGENT_BUILDER_LIST: 'apps/AGENT_BUILDER_LIST',
  BUILDER_RESET: 'apps/BUILDER_RESET',
  MULTITENANT_GET_USAGE: 'apps/MULTITENANT_GET_USAGE',
  NOTIFICATION_LOGS: 'apps/NOTIFICATION_LOGS',
  UPDATE_MODERATION_GLOBAL_SETTINGS: 'apps/UPDATE_MODERATION_GLOBAL_SETTINGS',
  GET_MODERATION_GLOBAL_SETTINGS: 'apps/GET_MODERATION_GLOBAL_SETTINGS',
  UPDATE_GET_STARTED_FEATURE_SCREEN_BEHAVIOUR: 'apps/UPDATE_GET_STARTED_FEATURE_SCREEN_BEHAVIOUR',
  AI_AGENT_USER_LIST: 'apps/AI_AGENT_USER_LIST',
  ADD_CUSTOM_CATEGORY: 'apps/ADD_CUSTOM_CATEGORY',
  FETCH_CUSTOM_CATEGORIES: 'apps/FETCH_CUSTOM_CATEGORIES',
  DELETE_CUSTOM_CATEGORY: 'apps/DELETE_CUSTOM_CATEGORY',
  UPDATE_CUSTOM_CATEGORY: 'apps/UPDATE_CUSTOM_CATEGORY',
  GET_FLAGGEDBY_USERS: 'apps/GET_FLAGGEDBY_USERS',
  AI_SEARCH_TOOLS_LIST: 'apps/AI_SEARCH_TOOLS_LIST',
  SET_TOOLS_SEARCH_LOADING: 'apps/SET_TOOLS_SEARCH_LOADING',
  SET_TOOLS_SEARCH_RESULT: 'apps/SET_TOOLS_SEARCH_RESULT',
}

export default actions
